/* eslint-disable multiline-ternary */
import styles from './FinalTab.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { type RootState } from '../../store/store'
import { clearSavedReservationAction, selectReservationDatesAction, setStellantisParentNotifySubmitClick } from '../../store/reservationSlice'
import { StatusCodes } from '../../api/data/Enums'
import { getOEMName } from '../../modules/auth/helpers'
import { sendStellantisFormSubmitMessage } from '../../services/notify-service'

function FinalTab(): any {
  const rezResponse = useSelector((state: RootState) => state.reservationSlice.reservationResponse)
  const stellantisParentNotifySubmitClick: boolean = useSelector((state: RootState) => state.reservationSlice.stellantisParentNotifySubmitClick)

  const dispatch = useDispatch()

  if (rezResponse === undefined) {
    dispatch(clearSavedReservationAction(true))
    const emptyReservation = useSelector((state: RootState) => state.reservationSlice.reservation)
    dispatch(selectReservationDatesAction(emptyReservation))
  }

  if (rezResponse?.statusCode === StatusCodes.Success) {
    // If oem is Stellantis, post a message to the parent window indicating success
    if (getOEMName()?.toUpperCase()?.trim() === 'FCA GROUP' && !stellantisParentNotifySubmitClick) {
      sendStellantisFormSubmitMessage(rezResponse.data.formTransactionId)
      dispatch(setStellantisParentNotifySubmitClick(true))
    }
    return (
      <div className={styles.FinalTab} data-testid='FinalTab'>
        Thank you, <br /> we will see you soon!
      </div>
    )
  } else {
    return (
      <div className={styles.FinalTab} data-testid='FinalTab'>
        <p>SERVICE UNAVAILABLE, PLEASE CALL DEALERSHIP TO SCHEDULE.</p>
      </div>
    )
  }
}

export default FinalTab
